import type { GameActionRequest, PlayerAction } from '@bioforge/protocol';

export interface ActionEnvelope {
  readonly matchId: string;
  readonly actionId: string;
  readonly seq: number;
}

/**
 * Нумерация действий игрока: монотонный seq внутри матча (общий для всех видов действий)
 * и уникальный actionId. Новый матч (в том числе повторный) начинает нумерацию заново.
 */
export class ActionSequencer {
  private matchId: string | null = null;
  private seq = 0;

  constructor(private readonly newId: () => string = () => crypto.randomUUID()) {}

  setMatch(matchId: string | null): void {
    if (matchId !== this.matchId) {
      this.matchId = matchId;
      this.seq = 0;
    }
  }

  envelope(): ActionEnvelope | null {
    if (!this.matchId) return null;
    return { matchId: this.matchId, actionId: this.newId(), seq: this.seq++ };
  }

  next(type: PlayerAction): GameActionRequest | null {
    const envelope = this.envelope();
    return envelope ? { ...envelope, action: { type } } : null;
  }
}
